import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const BootcampBadge = createSvgIcon(
  <path d="M8.25 0v6.06L12 7.962l3.75-1.904V0H18v7.44l-6 3.047L6 7.44V0h2.25Zm8.25 19.479v2.271h-2.271L12 23.979 9.771 21.75H7.5v-2.271L5.271 17.25 7.5 15.021V12.75h2.271L12 10.521l2.229 2.229H16.5v2.271l2.229 2.229-2.229 2.229Zm-2.25-.932v-2.594L13.296 15h-2.592l-.954.954v2.593l.954.953h2.592l.954-.953Z" />,
  'BootcampBadge'
);

export { BootcampBadge };